import { Suspense } from 'react';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import Reporting from 'src/sections/reporting/view';

import { rootRoute } from './root';

const reportingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'reporting',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const reportingIndexRoute = createRoute({
  getParentRoute: () => reportingRoute,
  path: '/',
  component: Reporting,
});

export const reportingRouteTree = reportingRoute.addChildren([reportingIndexRoute]);
